// remap jQuery to $
(function($){})(window.jQuery);


/* trigger when page is ready */
$(document).ready(function () {

	$("#checkout input[name=checkout]").click(function(e) {
		if ($('#agree').is(':checked')) {
			$('#checkout').submit();
		} else {
			alert("Please agree to the Terms and Conditions");
			e.preventDefault();
		}
	});

});


/* optional triggers

$(window).load(function() {
	
});

$(window).resize(function() {
	
});

*/